import { Cancel as CancelIcon, EditLocation as EditLocationIcon } from "@mui/icons-material";
import { IconButton, TextField } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import { usePlacesWidget } from "react-google-autocomplete";
import { MAPS_API_KEY, MAPS_LIBRARIES, useGooglePlaceName } from "../../misc/googleMaps";

interface PlaceSelectProps {
  readonly onSelect: (googlePlaceId: string, placeName: string) => void;
  readonly onCancel: () => void;
}

const PlaceSelect: FC<PlaceSelectProps> = ({ onSelect, onCancel }) => {
  const { ref } = usePlacesWidget({
    apiKey: MAPS_API_KEY,
    options: {
      types: null as unknown as string[], // must be explicitly set to show all types of places
      fields: ["place_id", "name"],
    },
    libraries: MAPS_LIBRARIES,
    onPlaceSelected: (place) => {
      if (place?.place_id && place?.name) {
        onSelect(place.place_id, place.name);
      }
    },
  });
  return (
    <TextField
      inputRef={ref}
      label="Wyszukaj miejsce"
      fullWidth
      slotProps={{
        input: {
          endAdornment: (
            <IconButton onClick={() => onCancel()}>
              <CancelIcon />
            </IconButton>
          ),
        },
      }}
    />
  );
};

interface Props {
  readonly googlePlaceId: string | undefined;
  readonly onChange: (googlePlaceId: string | undefined) => void;
}

const GooglePlaceSelect: FC<Props> = ({ googlePlaceId, onChange }) => {
  const [editMode, setEditMode] = useState<boolean>(false);
  const { placeName, setPlaceName } = useGooglePlaceName(googlePlaceId);

  return editMode ? (
    <PlaceSelect
      onSelect={(id, name) => {
        onChange(id);
        setPlaceName(name);
        setEditMode(false);
      }}
      onCancel={() => setEditMode(false)}
    />
  ) : (
    <TextField
      label="Lokalizacja Google"
      fullWidth
      value={placeName}
      slotProps={{
        input: {
          readOnly: true,
          endAdornment: (
            <IconButton onClick={() => setEditMode(true)}>
              <EditLocationIcon />
            </IconButton>
          ),
        },
        inputLabel: {
          shrink: true,
        },
      }}
    />
  );
};

export default GooglePlaceSelect;
